import withStep from '@/containers/withStep';

import ManagedCeo from './variants/ManagedCeo';
import DefaultCeo from './variants/DefaultCeo';

export const VARIANTS = [ManagedCeo, DefaultCeo];

export default withStep('Ceo', {
  id: 'ceo',
  description: 'Collects the CEOs of the company (Control Over Management role)',
  variants: VARIANTS,
});
